import { useQuery } from '@tanstack/react-query';
import getAvailableHostRequest from './model/request/getAvailableHostRequest';
import getAvailableHost from 'Api/schedule-ruleset/getAvailableHost';
import getAvailableHostResponse from './model/response/getAvailableHostResponse';

const useGetAvailableHost = ({ queryParams, rulesetDetail, enabled }) => {
  return useQuery({
    queryKey: ['ruleset-host', queryParams],
    queryFn: async () => {
      const queries = getAvailableHostRequest(queryParams);

      const response = await getAvailableHost(queries);

      const result = getAvailableHostResponse(response, rulesetDetail);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
  });
};

export default useGetAvailableHost;
